var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 126,
    width: 100,
    height: 100,
    rx: 20,
    transform: "rotate(90 226 126)",
    fill: "#2E2F33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 154C163.209 154 165 155.791 165 158L165 226L148 226L148 158C148 155.791 149.791 154 152 154L161 154Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 154C202.209 154 204 155.791 204 158L204 226L188 226L188 158C188 155.791 189.791 154 192 154L200 154Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 126,
    width: 100,
    height: 100,
    rx: 20,
    transform: "rotate(90 100 126)",
    fill: "#2E2F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 154C62.2843 154 69 160.716 69 169V169C69 177.284 62.2843 184 54 184L51.5 184C41.835 184 34 176.165 34 166.5L34 154L54 154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 195C61.165 195 69 202.835 69 212.5L69 226L34 226L34 212.5C34 202.835 41.835 195 51.5 195V195Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162.568,
    y: 0.568237,
    width: 100,
    height: 100,
    rx: 20,
    transform: "rotate(90 162.568 0.568237)",
    fill: "#2E2F33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.574 72.5735C130.25 76.8966 124.743 79.8407 118.746 81.0334C112.75 82.2261 106.535 81.614 100.886 79.2744C95.2379 76.9347 90.4102 72.9727 87.0136 67.8893C83.617 62.8059 81.804 56.8294 81.804 50.7157C81.804 44.6019 83.617 38.6255 87.0136 33.5421C90.4102 28.4587 95.2379 24.4967 100.886 22.157C106.535 19.8174 112.75 19.2053 118.746 20.398C124.743 21.5907 130.25 24.5348 134.574 28.8578L112.716 50.7157L134.574 72.5735Z",
    fill: "#FFFBFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.b78fede61950258e91656f91b6bdfdae.svg";
export { ForwardRef as ReactComponent };